<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("youtubeChannel.channelDetail") }}</div>
            <div class="subtitle">{{ $t("youtubeChannel.channelDetailDesc") }}</div>
        </div>
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("youtubeChannel.channelName") }}</label>
                    <a-input
                        :placeholder="$t('youtubeChannel.channelName')"
                        v-model="clone.name"
                        name="channelName"
                    />
                </div>
                <div class="input-wrapper" v-if="clone.payload && clone.payload.youtubeChannelTitle">
                    <label>{{ $t("youtubeChannel.youtubeChannel") }}</label>
                    <div class="youtube-channel-info">
                        <img
                            v-if="clone.payload.youtubeChannelThumbnail"
                            :src="clone.payload.youtubeChannelThumbnail"
                            alt="Channel Thumbnail"
                            class="channel-thumbnail"
                        />
                        <span>{{ clone.payload.youtubeChannelTitle }}</span>
                    </div>
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("youtubeChannel.status") }}</label>
                    <a-switch v-model="clone.enabled" />
                    <span class="status-label">{{ clone.enabled ? $t("youtubeChannel.active") : $t("youtubeChannel.inactive") }}</span>
                </div>
            </div>
        </a-form>
        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :loading="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import _ from "lodash";

export default Vue.extend({
    name: "UpdateDetail",
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
        };
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleSave() {
            const isChanged = !_.isEqual(this.value, this.clone);
            if (!isChanged) {
                return;
            }
            this.loading = true;
            this.updateChannel(this.clone)
                .then(() => {
                    this.listChannels();
                    this.$message.success(this.$t("youtubeChannel.channelUpdatedSuccess"));
                    this.$emit("input", this.clone);
                    this.$emit("saved");
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(this.$t("youtubeChannel.failedUpdateChannel"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        value: {
            handler(val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-default);
        }
    }

    .form-wrapper {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: 500px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 8px;

            label {
                font-weight: 500;
            }

            .youtube-channel-info {
                display: flex;
                align-items: center;
                gap: 10px;

                .channel-thumbnail {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }
            }

            .status-label {
                margin-left: 10px;
            }
        }
    }

    .form-footer {
        margin-top: 20px;

        .actions {
            display: flex;
            gap: 10px;
        }
    }
}
</style>
